import * as tslib_1 from "tslib";
import { observable } from 'mobx';
import { TaskStatus } from '../models/TaskStatus';
import { stringComparer } from 'src/utils/comprasion';
import { getViewOptionFilter, MINE } from './TaskViewOptions';
import { getTaskTypeFilter, ALL } from './TaskTypeOptions';
var TaskFilter = /** @class */ (function () {
    function TaskFilter(userStore) {
        var _this = this;
        this.userStore = userStore;
        this.projectName = '';
        this.title = '';
        this.description = '';
        this.tagCloud = '';
        this.statusName = '';
        this.competencyName = '';
        this.userName = '';
        this.stepName = '';
        this.viewOption = MINE;
        this.typeOption = ALL;
        this.fullTextSearch = '';
        this.priority = '';
        this.applyOn = function (tasks) {
            if (!tasks || tasks.length === 0) {
                return [];
            }
            if (_this.fullTextSearch) {
                return _this.applyFullText(tasks);
            }
            return tasks
                .filter(function (i) { return !_this.userStore.loggedInUserIsAdmin || getViewOptionFilter(_this.viewOption)(i, _this.userStore); })
                .filter(function (i) { return getTaskTypeFilter(_this.typeOption)(i); })
                .filter(function (i) { return stringComparer(i.project, _this.projectName); })
                .filter(function (i) { return stringComparer(i.description, _this.description); })
                .filter(function (i) { return stringComparer(i.title, _this.title); })
                .filter(function (i) { return stringComparer(TaskStatus.stringify(i.statusId), _this.statusName); })
                .filter(function (i) { return stringComparer(i.competency, _this.competencyName); })
                .filter(function (i) { return stringComparer(i.userName, _this.userName); })
                .filter(function (i) { return stringComparer(i.stepName, _this.stepName); })
                .filter(function (i) { return stringComparer(i.ticketPriority, _this.priority); })
                .filter(function (i) { return stringComparer(i.tagCloud, _this.tagCloud); });
        };
        this.applyFullText = function (tasks) {
            return tasks
                .filter(function (i) { return !_this.userStore.loggedInUserIsAdmin || getViewOptionFilter(_this.viewOption)(i, _this.userStore); })
                .filter(function (i) { return getTaskTypeFilter(_this.typeOption)(i); })
                .filter(function (i) { return stringComparer(i.project, _this.fullTextSearch) ||
                stringComparer(i.description, _this.fullTextSearch) ||
                stringComparer(i.title, _this.fullTextSearch) ||
                stringComparer(TaskStatus.stringify(i.statusId), _this.fullTextSearch) ||
                stringComparer(i.competency, _this.fullTextSearch) ||
                stringComparer(i.userName, _this.fullTextSearch) ||
                stringComparer(i.stepName, _this.fullTextSearch) ||
                stringComparer(i.ticketPriority, _this.fullTextSearch); });
        };
        window.addEventListener('keyup', function (e) {
            if (e.key === 'Escape') {
                _this.clear();
            }
        });
    }
    TaskFilter.prototype.setValue = function (key, value) {
        var _a;
        if (key in this) {
            Object.assign(this, (_a = {}, _a[key] = value, _a));
        }
    };
    TaskFilter.prototype.clear = function () {
        Object.assign(this, {
            projectName: null,
            title: null,
            description: null,
            statusName: null,
            competencyName: null,
            userName: null,
            stepName: null,
            priority: null,
            overwork: null,
            tagCloud: null
        });
    };
    tslib_1.__decorate([
        observable
    ], TaskFilter.prototype, "projectName", void 0);
    tslib_1.__decorate([
        observable
    ], TaskFilter.prototype, "title", void 0);
    tslib_1.__decorate([
        observable
    ], TaskFilter.prototype, "description", void 0);
    tslib_1.__decorate([
        observable
    ], TaskFilter.prototype, "tagCloud", void 0);
    tslib_1.__decorate([
        observable
    ], TaskFilter.prototype, "statusName", void 0);
    tslib_1.__decorate([
        observable
    ], TaskFilter.prototype, "competencyName", void 0);
    tslib_1.__decorate([
        observable
    ], TaskFilter.prototype, "userName", void 0);
    tslib_1.__decorate([
        observable
    ], TaskFilter.prototype, "stepName", void 0);
    tslib_1.__decorate([
        observable
    ], TaskFilter.prototype, "viewOption", void 0);
    tslib_1.__decorate([
        observable
    ], TaskFilter.prototype, "typeOption", void 0);
    tslib_1.__decorate([
        observable
    ], TaskFilter.prototype, "fullTextSearch", void 0);
    tslib_1.__decorate([
        observable
    ], TaskFilter.prototype, "priority", void 0);
    return TaskFilter;
}());
export default TaskFilter;



//////////////////
// WEBPACK FOOTER
// ./src/models/TaskFilter.ts
// module id = 196
// module chunks = 0